export default __webpack_public_path__ + "static/media/cat-2.c77659f3.svg";